import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0494274 4.25744C0.0811566 4.33928 0.128734 4.41404 0.189428 4.47744L3.52276 7.81077C3.58492 7.87293 3.65871 7.92224 3.73993 7.95588C3.82114 7.98952 3.90819 8.00684 3.99609 8.00684C4.17363 8.00684 4.34389 7.93631 4.46943 7.81077C4.53159 7.74862 4.58089 7.67482 4.61453 7.59361C4.64817 7.51239 4.66549 7.42535 4.66549 7.33744C4.66549 7.15991 4.59496 6.98964 4.46943 6.86411L2.26943 4.67077L7.32943 4.67077C7.50624 4.67077 7.67581 4.60054 7.80083 4.47551C7.92586 4.35049 7.99609 4.18092 7.99609 4.00411C7.99609 3.8273 7.92586 3.65773 7.80083 3.5327C7.67581 3.40768 7.50624 3.33744 7.32943 3.33744L2.26943 3.33744L4.46943 1.14411C4.53191 1.08213 4.58151 1.0084 4.61536 0.92716C4.6492 0.84592 4.66663 0.758783 4.66663 0.670775C4.66663 0.582767 4.6492 0.49563 4.61536 0.414391C4.58151 0.333151 4.53191 0.259418 4.46943 0.197443C4.40745 0.134957 4.33372 0.0853597 4.25248 0.0515138C4.17124 0.0176679 4.0841 0.000242845 3.99609 0.000242837C3.90809 0.00024283 3.82095 0.0176679 3.73971 0.0515138C3.65847 0.0853597 3.58474 0.134957 3.52276 0.197443L0.189428 3.53077C0.128734 3.59418 0.0811566 3.66894 0.0494274 3.75077C-0.0172516 3.91308 -0.0172516 4.09513 0.0494274 4.25744Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowLeftIcon = (props) => (
  <Icon component={Component} {...props} />
);
